import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';

import { NotificationBar } from '@eb/eds-notification';
import { TYPE_ERROR } from '@eb/eds-notification';
import { withMainControls } from '@eb/eds-structure';

import { AlertChunky } from '@eb/eds-iconography';

import SplitContainer from '../../components/SplitContainer';
import PageHeader from '../../components/PageHeader';

import ConnectedEventbriteLoginOptions from '../../connectedComponents/EventbriteLoginOptions';
import ConnectedSocialLoginOptions from '../../connectedComponents/ConnectedSocialLoginOptions';
import ConnectedEventbritePrivacyTerms from '../../connectedComponents/PrivacyTerms';

import { setSocialMocks } from '../../utils/socialMocks';

import './LoginPage.scss';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/LOG_IN_PATH
 */

//  In develpment message, remove once the flow is finished and in production
const DevelopmentMessage = () => {
    return (
        <div className="development-banner">
            <NotificationBar
                type={TYPE_ERROR}
                iconType={<AlertChunky />}
                hasCloseButton={true}
            >
                {gettext(
                    'This is a development version of login, design is not final. Please, for any kind of errors contact Teemo in #teemo. Thanks.',
                )}
            </NotificationBar>
        </div>
    );
};

class LoginPage extends React.PureComponent {
    static propTypes = {
        clearAuthNotification: PropTypes.func,
        onSocialProviderClick: PropTypes.func,
        onSocialLogInUser: PropTypes.func,
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;
        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });
            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;
        this._hasNotification = false;
        hideMainNotification && hideMainNotification();
    };

    /**
     * Social login functions probably can be moved to actions as it is not doing anything with the component
     */
    _handleOnSocialLogIn = (socialProvider, socialResponse) => {
        const {
            clearAuthNotification,
            onSocialLogInUser,
            socialSSOSettings,
        } = this.props;

        // clear notification everytime form is submitted
        if (clearAuthNotification) {
            clearAuthNotification();
        }

        // add param to call api, depending on feature flag
        let skipCreation = false;

        if (socialSSOSettings) {
            skipCreation = socialSSOSettings.twoStepsSignup || false;
        }

        if (onSocialLogInUser) {
            onSocialLogInUser(socialProvider, {
                skipCreation,
                ...socialResponse,
            });
        }
    };

    _handleOnSocialProviderClick = async (
        socialProvider,
        stateFromProvider,
    ) => {
        const {
            onSocialProviderClick,
            // Social mocking props
            onSkipSocialLinks,
        } = this.props;

        await setSocialMocks({ socialProvider, onSkipSocialLinks });

        if (onSocialProviderClick) {
            onSocialProviderClick({
                socialProvider,
                stateFromProvider,
            });
        }
    };
    /**
     * Social login functions
     */

    render() {
        const pageHeaderProps = {
            headerText: gettext('Log in'),
            subtitleText: gettext('and find the best events for you'),
        };
        const buttonCTA = gettext('Log in');

        return (
            <>
                <DevelopmentMessage />
                <SplitContainer>
                    <>
                        <PageHeader {...pageHeaderProps} />
                        <ConnectedEventbriteLoginOptions
                            buttonCTA={buttonCTA}
                            handleShowNotification={
                                this._handleShowNotification
                            }
                            handleClearNotification={
                                this._handleClearNotification
                            }
                        />
                        <div className="split-container__divider eds-l-pad-bot-8">
                            <div className="split-container__divider-text eds-text-bm eds-text-weight--heavy">
                                {gettext('or')}
                            </div>
                        </div>

                        <div data-automation="social-login-section">
                            <ConnectedSocialLoginOptions
                                onSocialConnectVerified={
                                    this._handleOnSocialLogIn
                                }
                                handleSocialProviderClick={
                                    this._handleOnSocialProviderClick
                                }
                            />
                        </div>

                        <ConnectedEventbritePrivacyTerms />
                    </>
                </SplitContainer>
            </>
        );
    }
}

export default withMainControls(LoginPage);
